// extracted by mini-css-extract-plugin
module.exports = {"counter":"Abundance_counter__Dk5s2","abundance":"Abundance_abundance__nXn5S"};